export const showroomStats = [
  { value: "8,000", unit: "sq ft", label: "Showroom Floor" },
  { value: "200+", unit: "", label: "Pieces on Display" },
  { value: "15", unit: "yrs", label: "In West Loop" },
  { value: "12", unit: "", label: "Design Consultants" },
];

export const showroomSpaces = [
  {
    id: 1,
    name: "The Living Room Floor",
    description: "Sofas, sectionals, and lounge seating arranged in full room vignettes — so you can see exactly how each piece lives in a real space.",
    image: "https://readdy.ai/api/search-image?query=luxury%20furniture%20showroom%20living%20room%20display%2C%20large%20open%20floor%20plan%20with%20high%20ceilings%2C%20curated%20sofa%20sectional%20arrangement%2C%20warm%20pendant%20lighting%2C%20polished%20concrete%20floors%2C%20editorial%20interior%20photography%2C%20moody%20dramatic%20atmosphere%2C%20dark%20tones%20with%20warm%20amber%20accents%2C%20Chicago%20loft%20aesthetic&width=900&height=600&seq=601&orientation=landscape",
    tag: "Level 1",
  },
  {
    id: 2,
    name: "The Dining Gallery",
    description: "Every dining table in our collection, set and styled. Pair them with our full range of chairs, benches, and sideboards.",
    image: "https://readdy.ai/api/search-image?query=upscale%20furniture%20showroom%20dining%20room%20gallery%2C%20long%20solid%20oak%20dining%20tables%20with%20designer%20chairs%2C%20dramatic%20overhead%20pendant%20lights%2C%20dark%20moody%20interior%2C%20editorial%20photography%2C%20warm%20wood%20tones%20against%20dark%20walls%2C%20sophisticated%20atmosphere&width=900&height=600&seq=602&orientation=landscape",
    tag: "Level 1",
  },
  {
    id: 3,
    name: "The Bedroom Suite",
    description: "Platform beds, nightstands, and dressers in fully dressed bedroom settings. Experience the complete collection before you commit.",
    image: "https://readdy.ai/api/search-image?query=luxury%20furniture%20showroom%20bedroom%20suite%20display%2C%20platform%20bed%20with%20linen%20headboard%2C%20walnut%20nightstands%2C%20soft%20ambient%20lighting%2C%20editorial%20interior%20photography%2C%20sophisticated%20dark%20tones%2C%20warm%20neutral%20textiles%2C%20high-end%20furniture%20store%20atmosphere&width=900&height=600&seq=603&orientation=landscape",
    tag: "Level 2",
  },
  {
    id: 4,
    name: "The Materials Library",
    description: "Touch every fabric, wood, and finish we offer. Our consultants will help you build the perfect custom configuration.",
    image: "https://readdy.ai/api/search-image?query=furniture%20showroom%20materials%20library%2C%20fabric%20swatches%20and%20wood%20samples%20displayed%20on%20dark%20shelving%2C%20leather%20samples%2C%20stone%20samples%2C%20professional%20interior%20photography%2C%20moody%20dark%20atmosphere%2C%20warm%20accent%20lighting%2C%20luxury%20material%20selection%20room&width=900&height=600&seq=604&orientation=landscape",
    tag: "Level 2",
  },
];

export const showroomExperiences = [
  {
    icon: "ri-user-heart-line",
    title: "Personal Design Consultation",
    description: "Sit down with one of our 12 in-house design consultants. Bring your floor plan, photos, or just your ideas — we'll help you build a space that's entirely yours.",
    duration: "60–90 min",
    price: "Complimentary",
  },
  {
    icon: "ri-palette-line",
    title: "Custom Configuration Studio",
    description: "Every piece in our collection can be customized. Choose your wood species, fabric, finish, and dimensions. Our consultants will walk you through every option.",
    duration: "45–60 min",
    price: "Complimentary",
  },
  {
    icon: "ri-home-4-line",
    title: "Room Planning Service",
    description: "Upload your room dimensions and we'll create a 3D layout showing exactly how your chosen pieces will look and fit in your space.",
    duration: "2–3 days",
    price: "Complimentary",
  },
  {
    icon: "ri-truck-line",
    title: "White-Glove Delivery",
    description: "Our in-house delivery team handles everything — delivery, assembly, and placement. We even take away the packaging. Available throughout the Chicago metro area.",
    duration: "Scheduled",
    price: "From $199",
  },
];

export const showroomGalleryImages = [
  {
    id: 1,
    image: "https://readdy.ai/api/search-image?query=close%20up%20detail%20of%20handcrafted%20solid%20walnut%20wood%20furniture%20joint%2C%20fine%20woodworking%20craftsmanship%2C%20warm%20studio%20lighting%2C%20dark%20background%2C%20macro%20photography%2C%20luxury%20furniture%20detail%2C%20artisan%20quality&width=480&height=600&seq=701&orientation=portrait",
    caption: "Handcrafted Joinery",
    span: "tall",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=modern%20furniture%20showroom%20interior%20wide%20shot%2C%20curated%20living%20room%20display%2C%20warm%20pendant%20lighting%2C%20concrete%20floors%2C%20editorial%20photography%2C%20sophisticated%20dark%20atmosphere%2C%20Chicago%20loft%20space&width=700&height=420&seq=702&orientation=landscape",
    caption: "The Main Floor",
    span: "wide",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=luxury%20leather%20lounge%20chair%20detail%2C%20cognac%20leather%20upholstery%20texture%2C%20brushed%20brass%20frame%20detail%2C%20professional%20product%20photography%2C%20dark%20moody%20background%2C%20warm%20accent%20lighting&width=480&height=420&seq=703&orientation=landscape",
    caption: "Halcyon Chair — Cognac",
    span: "normal",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=furniture%20showroom%20design%20consultation%20area%2C%20two%20people%20discussing%20furniture%20samples%20at%20a%20table%2C%20warm%20interior%20lighting%2C%20professional%20editorial%20photography%2C%20sophisticated%20atmosphere&width=480&height=420&seq=704&orientation=landscape",
    caption: "Design Consultation",
    span: "normal",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=solid%20oak%20dining%20table%20close%20up%20detail%2C%20live%20edge%20wood%20grain%20texture%2C%20fine%20furniture%20craftsmanship%2C%20warm%20studio%20lighting%2C%20dark%20background%2C%20luxury%20furniture%20photography&width=700&height=420&seq=705&orientation=landscape",
    caption: "Crestwood Table — White Oak",
    span: "wide",
  },
];

export const showroomHours = [
  { day: "Monday – Friday", time: "10:00 AM – 7:00 PM" },
  { day: "Saturday", time: "10:00 AM – 6:00 PM" },
  { day: "Sunday", time: "11:00 AM – 5:00 PM" },
];
